module.exports = __webpack_public_path__ + "static/media/extraordinary-machine.55444288.jpg";